import BaseSetup from '@/components/BaseSetup';
import useQualificationService from '@/services/QualificationService';
import { Reactive } from '@/utils/decorators';

export type SharedSelectAgencyQualificationsEmits = {
	(e: 'update:modelValue', ids?: number[]): void
};
export type SharedSelectAgencyQualificationsProps = {
	modelValue: number[]
	agencyCompanyId?: number
};

export default class SharedSelectAgencyQualificationsSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = { agencyQualificationsOptions: [] as IQualificationForListModel[] };

	get agencyQualificationsOptions () {
		const res = this.props.agencyCompanyId
			? this.state.agencyQualificationsOptions.filter(x => x.agencyCompanyId === this.props.agencyCompanyId)
			: this.state.agencyQualificationsOptions;

		return res.sort((a, b) => a.label!.localeCompare(b.label!));
	}

	get agencyQualificationId () { return this.props.modelValue }
	set agencyQualificationId (val) { this.emits('update:modelValue', val) }

	constructor (
		private props: SharedSelectAgencyQualificationsProps,
		private emits: SharedSelectAgencyQualificationsEmits,
	) {
		super();
	}

	protected async onBeforeMountAsync (): Promise<void> {
		this.state.agencyQualificationsOptions = await useQualificationService().listAsync();
	}

}
